import { Loading } from "@/components/ui/loading";
import { BikeDetailsRoute } from "@/modules/bikes/routes/bike-details.route";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/bikes/$bikeId/")({
	component: BikeDetailsRoute,
	pendingComponent: Loading,
});
